import Vue from 'vue'

Vue.filter('pmlWordBeautify', function (value) {
    value = value.split('_').join(' ')
    return value.replace(/\b[a-z]/g, (f) => f.toUpperCase())
})



// WEBPACK FOOTER //
// ./src/utils/filters/word-beautify.js